/*
 * File: CreateSalesOrder.ts
 * Project: papa-bear
 * -----
 * Last Modified: 13 May 2021 11:31:04 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

export enum CreateSalesOrderType {
  ATTENTION = 'Attention',
  BUYER = 'Buyer',
  CONTACT = 'Contact',
  CUSTOMER_ID = 'Customer Id',
  CUSTOMER_NAME = 'Customer Name',
  CUSTOMER_PO = 'Customer PO',
  DELIVERY_ADDRESS = 'Delivery Address',
  DELIVERY_CONTACT = 'Delivery Contact',
  DELIVERY_PHONE = 'Delivery Phone',
  DESCRIPTION = 'Delivery Description',
  DELIVERY_NAME = 'Delivery Name',
  FREIGHT_TERMS = 'Freight Terms',
  LAB_CONFIGURATION = 'Is Lab Configuration Required',
  MODE_OF_DELIVERY = 'Mode of Delivery',
  PAYMENT_TERMS = 'Payment Terms',
  QUOTE_ID = 'Quote Id',
  REQUEST_SHIP_DATE = 'Request Ship Date',
  SALES_ORDER_TYPE = 'Sales Order Type',
  SALES_SUPPORT = 'Sales Support',
  SALESPERSON = 'Salesperson',
  SHIP_COMPLETE = 'Is Ship Complete',
  SITE = 'Site',
  WAREHOUSE = 'Warehouse'
}
